import whiteStarPic from '@/assets/images/white-star.png';

export default function Market() {
  return (
    <div className="py-16 hidden">
      <div className="flex items-center gap-3 mb-12">
        <img src={whiteStarPic} alt="Star" className="h-[24px] sm:h-[28px] md:h-[32px] lg:h-[36px] w-auto" />
        <h2 className="text-3xl font-bold">市场分析</h2>
      </div>
      <div className="max-w-4xl mx-auto">
        <div className="bg-gray-900 p-8 rounded-xl mb-8">
          <h3 className="text-2xl font-bold mb-4">市场概览</h3>
          <p className="text-gray-300 leading-relaxed">
            全球科技创新投资市场正在经历前所未有的变革。AI 技术的快速发展、
            太空探索的商业化、生物科技的突破，都为投资者带来了新的机遇。
            我们持续关注市场动态，为投资者提供专业的市场分析和投资建议。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div className="bg-gray-900 p-6 rounded-xl">
            <h3 className="text-xl font-bold mb-4">市场趋势</h3>
            <div className="space-y-4">
              <div>
                <h4 className="font-semibold mb-2">AI 市场</h4>
                <div className="h-2 bg-gray-800 rounded-full">
                  <div className="h-full bg-blue-500 rounded-full" style={{ width: '80%' }}></div>
                </div>
                <p className="text-sm text-gray-400 mt-1">预计 2025 年市场规模将达到 2 万亿美元</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2">太空科技</h4>
                <div className="h-2 bg-gray-800 rounded-full">
                  <div className="h-full bg-blue-500 rounded-full" style={{ width: '65%' }}></div>
                </div>
                <p className="text-sm text-gray-400 mt-1">预计 2025 年市场规模将达到 1.5 万亿美元</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2">生物科技</h4>
                <div className="h-2 bg-gray-800 rounded-full">
                  <div className="h-full bg-blue-500 rounded-full" style={{ width: '75%' }}></div>
                </div>
                <p className="text-sm text-gray-400 mt-1">预计 2025 年市场规模将达到 1.8 万亿美元</p>
              </div>
            </div>
          </div>

          <div className="bg-gray-900 p-6 rounded-xl">
            <h3 className="text-xl font-bold mb-4">投资机会</h3>
            <ul className="text-gray-300 space-y-3">
              <li className="flex items-start gap-2">
                <span className="text-blue-500">•</span>
                <span>AI 基础设施与算力需求持续增长</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-500">•</span>
                <span>商业航天领域快速发展</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-500">•</span>
                <span>基因编辑与细胞治疗突破</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-500">•</span>
                <span>量子计算商业化加速</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-gray-900 p-6 rounded-xl">
          <h3 className="text-xl font-bold mb-4">风险提示</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 bg-gray-800 rounded-lg">
              <h4 className="font-semibold mb-2">市场风险</h4>
              <p className="text-sm text-gray-300">科技创新领域投资具有较高的市场波动性</p>
            </div>
            <div className="p-4 bg-gray-800 rounded-lg">
              <h4 className="font-semibold mb-2">技术风险</h4>
              <p className="text-sm text-gray-300">技术发展不及预期可能影响投资回报</p>
            </div>
            <div className="p-4 bg-gray-800 rounded-lg">
              <h4 className="font-semibold mb-2">政策风险</h4>
              <p className="text-sm text-gray-300">监管政策变化可能影响行业发展</p>
            </div>
            <div className="p-4 bg-gray-800 rounded-lg">
              <h4 className="font-semibold mb-2">流动性风险</h4>
              <p className="text-sm text-gray-300">部分投资标的可能存在流动性限制</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
